//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as StandardExamsActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';
import * as Sentry from "@sentry/react";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List standard exams ------
export const handleListStandardExams = () => async (dispatch) => {
    await dispatch(StandardExamsActions.listStandardExamss());

    try {
        const standardexams = await apis.get('standardexams', `/list_standard_exam`);
        if (Array.isArray(standardexams)) {
            await dispatch(StandardExamsActions.listStandardExamssSuccess(standardexams));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing standard exams',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'LIST_SENTENCE_STARTER'
            });
        }
        await dispatch(StandardExamsActions.listStandardExamssFail(error));
    }
};

export const handleCreateStandardExams = (data) => async (dispatch) => {
    await dispatch(StandardExamsActions.createStandardExams());
    try {
        const standardexam = await apis.post('standardexams', `/create_standard_exams`, {
            body: data
        });
        if (has(standardexam, "id")) {
            await dispatch(StandardExamsActions.createStandardExamsSuccess(standardexam));
        }
        return standardexam;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating standard exams',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'CREATE_SENTENCE_STARTER'
            });
        }
        await dispatch(StandardExamsActions.createStandardExamsFail(error));
    }
};

export const handleUpdateStandardExams = (data) => async (dispatch) => {
    await dispatch(StandardExamsActions.updateStandardExams());
    try {
        const standardexam = await apis.put('standardexams', `/update_standard_exam`, {
            body: data
        });
        if (has(standardexam, "id")) {
            await dispatch(StandardExamsActions.updateStandardExamsSuccess(standardexam));
        }
        return standardexam;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating standard exams',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'UPDATE_SENTENCE_STARTER'
            });
        }
        await dispatch(StandardExamsActions.updateStandardExamsFail(error));
    }
};

export const handleDeleteStandardExam = (id) => async (dispatch) => {
    await dispatch(StandardExamsActions.deleteStandardExams());
    try {
        const standardexam = await apis.del('standardexams', `/delete_standard_exam/${id}`);
        if (standardexam && standardexam.id) {
            await dispatch(StandardExamsActions.deleteStandardExamsSuccess(id));
        }
        return standardexam;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting standard exam',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'DELETE_SENTENCE_STARTER'
            });
        }
        await dispatch(StandardExamsActions.deleteStandardExamsFail(error));
    }
};

export const handleListFilterRecords = (data) => async (dispatch) => {
    try {
        const standardexam = await apis.post('standardexams', `/get_filter_report_data`,{
            body: data
        });
        return standardexam;
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`876 Error deleting standard exam: ${error}`);
        }
    }
};

export const handleListCourseInfo = (data) => async (dispatch) => {
    try {
        const courseInfo = await apis.post('standardexams', `/get_course_info`, {
            body: data
        });
        return courseInfo;
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`877 Error listing course info: ${error}`);
        }
    }
};

export const handleGetStudentMissing = (data) => async (dispatch) => {
    try {
        const studentMissing = await apis.post('standardexams', `/get_student_missing`, {
            body: data
        });
        return studentMissing;
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`877 Error getting student missing: ${error}`);
        }
    }
};

export const handleGetAllTeachers = (data) => async (dispatch) => {
    try {
        const allTeachers = await apis.post('standardexams', `/get_all_teacher_info`, {
            body: data
        });
        return allTeachers;
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`877 Error getting student missing: ${error}`);
        }
    }
};
export const handleGetSupportNeedList = (orgId, session) => async (dispatch) => {
    try {
        const response = await apis.post('standardexams', `/get_support_need_list`, {
            body: {
                orgId: orgId,
                session: session
            }
        });
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting support need list',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_SUPPORT_NEED_LIST'
            });
        }
    }
};
export const handleGetSupportNeedListProficiency = (data) => async (dispatch) => {
    try {
        const response = await apis.post('standardexams', `/get_teacher_need_support_proficiency_exam`, {
            body: data
        });
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting support need list proficiency',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_SUPPORT_NEED_LIST_PROFICIENCY'
            });
        }
    }
};
export const handleListSchools = (data) => async (dispatch) => {
    try {
        const schools = await apis.post('standardexams', `/get_all_schools`, {
            body: data
        });
        return schools;
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`877 Error getting all school info: ${error}`);
        }
    }
};
export const handleGetTeacherInfo = (data) => async (dispatch) => {
    try {
        const teacherInfo = await apis.post('standardexams', `/get_teacher_info`, {
            body: data
        });
        return teacherInfo;
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`877 Error getting teacher info: ${error}`);
        }
    }
};


export const handleGetSchoolInfo = (data) => async (dispatch) => {
    try {
        const schoolInfo = await apis.post('standardexams', `/get_school_info`, {
            body: data
        });
        return schoolInfo;
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`877 Error getting school info: ${error}`);
        }
    }
};

export const handleGetMostPassedByGrade = (data) => async (dispatch) => {
    try {
        const mostPassedByGrade = await apis.post('standardexams', `/get_most_passed_by_grade`, {
            body: data
        });
        return mostPassedByGrade;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting most passed by grade',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_MOST_PASSED_BY_GRADE'
            });
        }
    }
};

export const handleGetMostFailedByGrade = (data) => async (dispatch) => {
    try {
        const mostFailedBySchool = await apis.post('standardexams', `/get_most_failed_by_grade`, {
            body: data
        });
        return mostFailedBySchool;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting most failed by school',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_MOST_FAILED_BY_SCHOOL'
            });
        }
    }
};

export const handleGetTeacherSubmissionDetails = (teacherId) => async (dispatch) => {
    try {
        const response = await apis.post('standardexams', `/get_teacher_submission_details`, {
            body: {
                teacherId: teacherId
            }
        });
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting teacher submission details',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_TEACHER_SUBMISSION_DETAILS'
            });
        }
        return { success: false, error: error.message };
    }
};

export const handleGetTeacherSubmissionDetailsProficiency = (data) => async (dispatch) => {
    try {
        const response = await apis.post('standardexams', `/get_teacher_submission_details_proficiency`, {
            body: data
        });
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting teacher submission details proficiency',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_TEACHER_SUBMISSION_DETAILS_PROFICIENCY'
            });
        }
        return { success: false, error: error.message };
    }
};

export const handleGetStudentSubmissionDetailsProficiency = (studentId, session, orgId, exam, classId = null, schoolLevel = null) => async (dispatch) => {
    try {
        const response = await apis.post('standardexams', `/get_student_submission_details_proficiency`, {
            body: {
                studentId: studentId,
                session: session,
                orgId: orgId,
                exam: exam,
                classId: classId,
                schoolLevel: schoolLevel
            }
        });
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting student submission details proficiency',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_STUDENT_SUBMISSION_DETAILS_PROFICIENCY'
            });
        }
        return { success: false, error: error.message };
    }
};

export const handleGetDomainPerformanceGraphData = (data) => async (dispatch) => {
    try {
        const domainPerformanceGraphData = await apis.post('standardexams', `/domain_performance_graph`, {
            body: data
        });
        return domainPerformanceGraphData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting domain performance graph data',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_DOMAIN_PERFORMANCE_GRAPH_DATA'
            });
        }
    }
};

export const handleGetExamTakenProficiency = (data) => async (dispatch) => {
    try {
        const placementExamGraphData = await apis.post('standardexams', `/get_exam_taken_proficiency`, {
            body: data
        });
        return placementExamGraphData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting domain performance graph data',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_DOMAIN_PERFORMANCE_GRAPH_DATA'
            });
        }
    }
};

export const handleGetExamTakenPerTeacher = (data) => async (dispatch) => {
    try{
        const examTakenPerTeacher = await apis.post('standardexams', `/get_exam_taken_per_teacher_proficiency`, {
            body: data
        });
        return examTakenPerTeacher;
    }catch(error){
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting exam taken per teacher',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_EXAM_TAKEN_PER_TEACHER'
            });
        }
    }
}

export const handleGetExamTakenPerSchoolProficiency = (data) => async (dispatch) => {
    try{
        const examTakenPerTeacherProficiency = await apis.post('standardexams', `/exam_taken_per_school_proficiency`, {
            body: data
        });
        return examTakenPerTeacherProficiency;
    }catch(error){
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting exam taken per teacher proficiency',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_EXAM_TAKEN_PER_TEACHER_PROFICIENCY'
            });
        }
    }
}


export const handleGetSubmissionStatusProficiency = (org_id, session , taken_course_id = null , missing_course_id = null, teacher_id = null, class_id = null) => async (dispatch) => {
    try{
        const submissionStatusProficiency = await apis.post('standardexams', `/submission_status_proficiency`, {
            body: {
                org_id: org_id,
                teacher_id: teacher_id,
                class_id: class_id,
                session: session,
                taken_course_id: taken_course_id,
                missing_course_id: missing_course_id
            }
        });
        return submissionStatusProficiency;
    }catch(error){
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting submission status proficiency',
                error,
                module: 'STANDARD_EXAMS',
                operation: 'GET_SUBMISSION_STATUS_PROFICIENCY'
            });
        }
    }
}

export const handleGetStandardExamCount = (data) => async (dispatch) => {
    try{
        const standardExamTakenData = await apis.post('standardexams', `/standard_status_count`, {
            body: data
        });
        return standardExamTakenData;
    }catch(error){
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting standard status count',
                error: error.message,
                module: 'STANDARD_EXAMS',
                operation: 'GET_STANDARD_STATUS_COUNT'
            });
        }
        return { success: false, error: error.message };
    }
}